import { EMPTY_QUILL_RE } from '@startuptools/common/common';
import DOMPurify from 'dompurify';

export const RichUserText = ({ children }: { children: string | null | undefined }) => {
  const sanitizedHTML = DOMPurify.sanitize(children ?? '').replace(EMPTY_QUILL_RE, '');
  return <span style={{ wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
};
